import { LoggerString } from './logger-string.class';
import { Severity } from './severity.enum';

export abstract class Logger {
  /**
   * General call for logging API.
   * @param message
   * @param {Severity} severity
   * @param {Error} error
   * @param metaData
   */
  abstract log(message: LoggerString, severity: Severity, error?: Error, ...metaData: any[]): void;

  /**
   * Log message with "information" severity.
   * @param message
   * @param metaData
   */
  info(message: LoggerString, ...metaData: any[]): void {
    this.log(message, Severity.Info, undefined, ...metaData);
  }

  /**
   * Log message with "warning" severity.
   * @param message
   * @param metaData
   */
  warn(message: LoggerString, ...metaData: any[]): void {
    this.log(message, Severity.Warning, undefined, ...metaData);
  }

  /**
   * Log message with "error" severity.
   * @param message
   * @param {Error} error
   * @param metaData
   */
  error(message: LoggerString, error?: Error, ...metaData: any[]): void {
    this.log(message, Severity.Error, error, ...metaData);
  }
}
